module.exports = __webpack_public_path__ + "img/download-QRcode.6cb50d6c.png";